import * as React from "react";
const DeployedIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M39.853 9.834a2.667 2.667 0 0 0-5.067 1.668 2.667 2.667 0 1 0 5.067-1.668ZM20.569 23.93a4.84 4.84 0 0 0-6.705.24L8.44 29.594a1.503 1.503 0 0 0 0 2.125l4.515 4.515a1.502 1.502 0 0 0 2.125 0l5.578-5.578a4.695 4.695 0 0 0-.09-6.726Zm15.54-8.288a3.292 3.292 0 0 1 1.53 4.395l-2.44 4.86-1.176 2.27a9.52 9.52 0 0 1 2.59 12.082 1.391 1.391 0 1 1-2.47-1.282 6.96 6.96 0 0 0-2.818-9.29l-2.5-1.252-6.21 11.815a1.392 1.392 0 1 1-2.48-1.264L31.312 16.71a7.458 7.458 0 0 0-7.388 3.876 1.38 1.38 0 1 1-2.455-1.256c2.292-4.479 8.012-6.673 12.58-4.685.104.024.204.06.299.107l1.762.89Z",
  clipRule: "evenodd"
}));
export default DeployedIcon;